module.exports = __webpack_public_path__ + "img/ds2.e30eba93.png";